import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=5aef40bd&scoped=true"
import script from "./AddressCard.vue?vue&type=script&lang=js"
export * from "./AddressCard.vue?vue&type=script&lang=js"
import style0 from "./AddressCard.vue?vue&type=style&index=0&id=5aef40bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef40bd",
  null
  
)

export default component.exports